import React from "react";

const SvgComponent = props => (
  <svg height="1em" viewBox="0 0 32 32" width="1em" {...props}>
    <circle cx={16} cy={16} r={24} fill="#fff" />
    <path
      d="M4 10h24a2 2 0 0 0 0-4H4a2 2 0 0 0 0 4zm24 4H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4zm0 8H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4z"
      fill="currentColor"
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./images/hamburger-icon.svg